import React, { useEffect, useState } from "react";
import { parseAdData } from "@/shared/FunctionCore";
import { ad } from "@/components/ads/AdComponent";

const SingleAds = ({AdName}) => {
  const [googleAdsBanner, setGoogleAdsBanner] = useState();


  useEffect(() => {
    const adComponentParameter = {
      adData: parseAdData(AdName.ad),
      identifier: "",
      properties: AdName,
    };
    setGoogleAdsBanner(adComponentParameter);
  }, []);

  return (
    <>
      {ad({ adComponentParameter: googleAdsBanner })}
    </>
  );
};

export default SingleAds;
